export default function PostContent({
  content,
}) {
  return (
    <div
      className="prose lg:prose-lg font-normal"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
